var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53.3333334px",
    height: "53.3333334px",
    viewBox: "0 0 53.3333334 53.3333334",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,8.8817842e-16 C41.394,8.8817842e-16 53.3333334,11.9393333 53.3333334,26.6666667 C53.3333334,41.3940001 41.394,53.3333334 26.6666667,53.3333334 C11.9393334,53.3333334 8.8817842e-16,41.394 8.8817842e-16,26.6666667 C8.8817842e-16,11.9393334 11.9393334,8.8817842e-16 26.6666667,8.8817842e-16 Z",
    fill: "#D42536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.262,18.56 C20.7806735,18.0707188 20.0738969,17.8771936 19.4104544,18.0530214 C18.7470119,18.2288492 18.2288492,18.7470119 18.0530214,19.4104544 C17.8771936,20.0738969 18.0707188,20.7806735 18.56,21.262 L23.9646667,26.6666667 L18.56,32.0713334 C18.0707188,32.5526599 17.8771936,33.2594365 18.0530214,33.922879 C18.2288492,34.5863215 18.7470119,35.1044842 19.4104544,35.280312 C20.0738969,35.4561398 20.7806735,35.2626146 21.262,34.7733334 L26.6666667,29.3686667 L32.0713334,34.7733334 C32.5526599,35.2626146 33.2594365,35.4561398 33.922879,35.280312 C34.5863215,35.1044842 35.1044842,34.5863215 35.280312,33.922879 C35.4561398,33.2594365 35.2626146,32.5526599 34.7733334,32.0713334 L29.3686667,26.6666667 L34.7733334,21.262 C35.2626146,20.7806735 35.4561398,20.0738969 35.280312,19.4104544 C35.1044842,18.7470119 34.5863215,18.2288492 33.922879,18.0530214 C33.2594365,17.8771936 32.5526599,18.0707188 32.0713334,18.56 L26.6666667,23.9646667 L21.262,18.56 Z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.36b031adaaa9ebf07b010bd46cd49fbe.svg";
export { ForwardRef as ReactComponent };